import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { Property } from './listings.models';
import { Amenity, BookingDetails, PropertyType } from 'src/app/shared/models';

export interface ListingState {
  list: Property[];
  detail: any | null;
  isLoading: boolean;
  error: string | null;
  amenities: Amenity[];
  propertyTypes: PropertyType[];
  bookings: BookingDetails[];
}

export const initialState: ListingState = {
  list: [],
  detail: null,
  isLoading: false,
  error: null,
  amenities: [],
  propertyTypes: [],
  bookings: [],
};

const selectListingDataState: MemoizedSelector<object, ListingState> = createFeatureSelector<ListingState>('listings');

const getListingsState = (state: ListingState) => state.list;
const getAmenities = (state: ListingState) => state.amenities;
const getPropertyTypes = (state: ListingState) => state.propertyTypes;
const getPropertyDetails = (state: ListingState) => state.detail;
const getIsLoading = (state: ListingState) => state.isLoading;
const getBookings = (state: ListingState) => state.bookings;

export const selectListings: MemoizedSelector<object, Property[]> = createSelector(
  selectListingDataState,
  getListingsState,
);

export const selectAmenities: MemoizedSelector<object, Amenity[]> = createSelector(
  selectListingDataState,
  getAmenities,
);

export const selectPropertyTypes: MemoizedSelector<object, PropertyType[]> = createSelector(
  selectListingDataState,
  getPropertyTypes,
);

export const selectPropertyDetails: MemoizedSelector<object, any> = createSelector(
  selectListingDataState,
  getPropertyDetails,
);

export const selectIsLoading: MemoizedSelector<object, boolean> = createSelector(selectListingDataState, getIsLoading);

export const selectBookings: MemoizedSelector<object, BookingDetails[]> = createSelector(
  selectListingDataState,
  getBookings,
);
